<template>

  <b-card class="card-bio cursor-pointer rounded" :id="`card-${bio.id}`" no-body footer-class="p-1 card-bio-footer d-flex flex-column lh-base" @click="seleccionarBio">
    <b-img :src="getPortada" thumbnail class="card-bio-portada" />
    <b-badge variant="morado" class="badge-tipo text-white" v-if="bio.configuracion.id">{{ bio.configuracion.tipo_nombre }}</b-badge>
    <template #footer>
      <strong class="card-bio-titulo cursor-pointer fs-5" @click="seleccionarBio">{{ bio.titulo }}</strong>
      <small v-if="autor_nombre">Por <strong class="text-morado"> {{ autor_nombre }}</strong></small>
    </template>

  </b-card>
</template>


<script setup>

import useAppStore from '@/store/app';

import useBiografia from '../../composables/biografia/useBiografia';
import PortadaDefault from '@images/portadas/portada_default.jpg';


const router = useRouter();


const props = defineProps({
  bio:Object,
  autor:Object
});

const model = defineModel({
  prop: 'bio',
  event: 'update'
});

const { bio,autor } = toRefs(props);
const emits = defineEmits(['mostrar-visor']);

const app_store = useAppStore();

const autor_nombre = computed(() => {
  if(bio.value.configuracion && bio.value.configuracion.autor_nombre){
    return `${bio.value.configuracion.nombre_apellido} (${bio.value.configuracion.apellido_autor})`;
  }
  return autor.value.full_name || '';
});

const seleccionarBio = () => {
  verBio(bio.value.url_ebook);
}

const verBio = (url) => {
  // Emitir el evento para mostrar el visor
  emits('mostrar-visor', url);
}

const getPortada = computed(() => {
  
  if (bio.value.portadas.length) {
    let portada1 = bio.value.portadas.find(portada => portada.posicion === 1);

    if(portada1){
      return portada1.url;
    }

    let contraportada = bio.value.portadas.find(portada => portada.posicion === 2);

    if(contraportada){
      return contraportada.url;
    }

    return PortadaDefault;

  }else {
    return PortadaDefault;
  }
});

</script>

<style lang="scss">
@import '@variables/variables';

.card-bio {
  max-width:209px;
  width:100%;
  margin:.5rem .5rem;
  position:relative;
  overflow: hidden;

  .card-bio-portada{
    max-height:277px;
    object-fit: contain;
    object-position: center center;
  }

  .badge-tipo{
    position:absolute;
    top:230px;
    left:20px;
  }
}

@media (min-width:6800px){
  .card-bio {
    width: calc(50% - 1rem);
  }
}


@media (min-width:768px){
  .card-bio {
    width: calc(50% - 1rem);
    
  }
}

@media (min-width:992px){
  .card-bio{
    width:calc(33.33% - 1rem);
  }
}

@media (min-width:1606px) {
  .card-bio {
      width: calc(25% - 1rem);
  }
}
</style>